document.addEventListener("DOMContentLoaded", function () {
  
	const featuredArticle = document.querySelector("#blog-articles--featured");

	const button = featuredArticle.querySelector(".card-button");

	// Check if the button exists
	if (button) {
		// Add the "button--secondary" class to the button
		button.classList.add("button--secondary");
	}

	/*	CHECK IF THE TOTAL NUMBER OF POSTS IN THE FEED IS EVEN OR ODD */
	const blogArticlesFeed = document.querySelectorAll(".blog-articles-feed");
	const blogArticlesFeedParent = document.getElementById("blog-articles-feed");

	if (blogArticlesFeed.length % 2 === 0) {
		blogArticlesFeedParent.classList.add("feed-even");
	} else {
		blogArticlesFeedParent.classList.add("feed-odd");
	}
});


// SINGLE POST: POSITION THE INNER PHOTOS
document.addEventListener("DOMContentLoaded", function () {
  var contentContainer = document.querySelector(".article-template__content");

  if (!contentContainer) return;

  // Create an observer instance
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        console.log("Detected changes in content, checking paragraphs...");

        repositionImageWrapper("blog-inner-photos-wrapper-one", innerPhotosPositionOne);

        repositionImageWrapper("blog-inner-photos-wrapper-two", innerPhotosPositionTwo);
      }
    });
  });

  var config = {
    attributes: false,
    childList: true,
    characterData: false,
    subtree: true,
  };

  // Pass in the target node, as well as the observer options
  observer.observe(contentContainer, config);

  // Function to reposition image wrapper, now parameterized
  function repositionImageWrapper(wrapperId, positionSetting) {
    var paragraphs = contentContainer.querySelectorAll("p");
    var photoWrapper = document.getElementById(wrapperId);
    var position = parseInt(positionSetting, 10) || 2; // Default to 2 if unspecified

    // Check if the position is within the bounds of the paragraph count
    if (photoWrapper && paragraphs.length >= position) {
      var targetParagraph = paragraphs[position - 1];

      // Move the photoWrapper to the right spot
      if (targetParagraph && targetParagraph.nextSibling) {
        targetParagraph.parentNode.insertBefore(photoWrapper, targetParagraph.nextSibling);
      } else {
        // If there is no next sibling, append to the end of the content container
        contentContainer.appendChild(photoWrapper);
      }
      console.log("Images repositioned for wrapper ID " + wrapperId + " after paragraph number:", position);

      // Once the photoWrapper is repositioned, disconnect the observer to stop watching for changes
      observer.disconnect();
      console.log("Mutation observer disconnected after successful reposition.");
    }
  }

  // Initial call to ensure positioning if the content is already present

  repositionImageWrapper(
    "blog-inner-photos-wrapper-one",
    innerPhotosPositionOne
  );

  repositionImageWrapper(
    "blog-inner-photos-wrapper-two",
    innerPhotosPositionTwo
  );
});
